<template>
<div class="chapter">
<div class="inner_page">
<p class="ded"><span><i>For my ancestors,</i></span></p>
<p class="ded1"><span><i>William and Oliver Showers,</i></span></p>
<p class="ded1"><span><i>who were there.</i></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// frontmatter01.vue?5364eb95